import { NavLink } from "react-router-dom";
import { useState } from "react";
import "./Sidebar.css";
import { getUser } from "../../services/authStore";
export default function Sidebar() {
  const user = getUser();
  const role = user?.role || "";
  const showSettings =
    role === "super_admin" ||
    role === "support_admin" ||
    role === "client_admin";
  const showStatus = role === "super_admin" || role === "support_admin";
  const [open, setOpen] = useState(false); // submenu
  const [mobileOpen, setMobileOpen] = useState(false); // mobile sidebar
  // Add this function inside your Sidebar component after the useState declarations
  const handleLinkClick = () => {
    if (window.innerWidth <= 1024) {
      setMobileOpen(false);
    }
  };
  const menuClass =
    "d-block text-decoration-none py-2 px-3 rounded mb-2 text-dark";

  const subMenuClass =
    "d-block text-decoration-none py-2 px-3 rounded mb-1 text-dark";

  return (
    <>
      {/* ☰ Mobile Toggle Button */}
      <button
        className="MenuBar_toggleBtn__73Piu"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Menu"
      >
        ☰
      </button>
      {/* Sidebar */}
      <div
        className={`sidebar bg-white border-end p-2 vh-100 ${
          mobileOpen ? "open" : ""
        }`}
        style={{ width: "200px", fontSize: "13.5px" }}
      >
        {/* Dashboard */}

        <NavLink
          to="/"
          className={menuClass}
          onClick={handleLinkClick} // Change this line
        >
          Home
        </NavLink>

        {/* Tickets */}
        <NavLink
          to="/tickets"
          className={menuClass}
          onClick={handleLinkClick} // Change this line
        >
          Tickets
        </NavLink>

        {/* Setting + Submenu Wrapper */}
        {showSettings && (
          <div
            onMouseEnter={() => {
              if (!("ontouchstart" in window)) setOpen(true);
            }}
          >
            <div
              className={menuClass}
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(!open)}
            >
              Setting
            </div>

            {open && (
              <ul className="ms-3 mt-1 sidebar-submenu">
                <li>
                  <NavLink
                    to="/ticketfield"
                    className={subMenuClass}
                    onClick={handleLinkClick} // Add this line
                  >
                    Ticket Field
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/emailsetting"
                    className={subMenuClass}
                    onClick={handleLinkClick} // Add this line
                  >
                    Email Setting
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/category"
                    className={subMenuClass}
                    onClick={handleLinkClick} // Add this line
                  >
                    Category
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/type"
                    className={subMenuClass}
                    onClick={handleLinkClick} // Add this line
                  >
                    Type
                  </NavLink>
                </li>

                {showStatus && (
                  <li>
                    <NavLink
                      to="/status"
                      className={subMenuClass}
                      onClick={handleLinkClick} // Add this line
                    >
                      Status
                    </NavLink>
                  </li>
                )}
              </ul>
            )}
          </div>
        )}
      </div>
      {/* ✅ This was missing */}
    </>
  );
}
